import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#172B85",
      "fill-rule": "evenodd",
      d: "M9.917 13.43H6.484L3.91 3.32c-.122-.464-.382-.876-.763-1.07A11 11 0 0 0 0 1.18V.792h5.53c.763 0 1.336.585 1.431 1.264l1.336 7.293L11.728.79h3.338zm7.057 0h-3.242L16.402.791h3.241zm6.864-9.137c.095-.68.668-1.07 1.335-1.07 1.05-.098 2.193.098 3.147.583l.573-2.721A8 8 0 0 0 25.937.5C22.79.5 20.5 2.25 20.5 4.68c0 1.849 1.622 2.82 2.767 3.404 1.239.583 1.716.972 1.62 1.555 0 .875-.954 1.264-1.906 1.264-1.145 0-2.29-.292-3.338-.779l-.572 2.723c1.145.486 2.383.681 3.528.681 3.529.096 5.721-1.653 5.721-4.278 0-3.306-4.482-3.5-4.482-4.957m15.829 9.137L37.092.791h-2.765c-.572 0-1.145.39-1.335.973L28.225 13.43h3.337l.666-1.846h4.101l.382 1.846zm-4.863-9.235.953 4.764h-2.67z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }